<template>
  <div class="component-container" style="display: block">
    <label v-if="showLabel()"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <div :style="inputStyle" class="mianzes">
      <div><el-button @click="show" type="primary">{{this.$t('html.EDIT')}}</el-button></div>
      <!-- <div v-html="value"></div> -->
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'jtHtmlEdit',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    value: {
      type: String,
      default: '',
    },
    compWidth: {
      type: String,
      default: '100%',
    },
    placeholder: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      val: this.value,
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      inputStyle: {
        width: window.innerWidth > 768 ? this.compWidth : '100%',
      },
      hasFiredEnterEventHandler: false,
    }
  },
  methods: {
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
    focus() {
      this.$refs.component.focus()
    },
    show() {
      this.$emit('htmlshow', this.defaultValue, this.value)
    },
    handleBlur() {
      try {
        if (this.hasFiredEnterEventHandler) {
          this.hasFiredEnterEventHandler = false
          return
        }
        this._save()
      } catch (err) {
        this.$emit('datas', err, null)
      }
    },

    _save() {
      const value = _.trim(this.val)
      if (!_.isEmpty(value)) {
        this._validate(value)
        this.val = value
      }

      this.$emit('datas', null, value)
    },
  },
}
</script>

<style lang="stylus">
.component-container {
  // display: block;
  // flex-direction: row;
  // align-items: baseline;
}

.component-container .is-disabled .el-input__inner {
  color: #666666;
}

.mianze {
  // max-height: 220px;
  border: 1px solid #DCDFE6;
  overflow-y: auto;
  margin-top: 8px;

  div {
    padding: 5px;
  }
}
</style>
